import { render, staticRenderFns } from "./ProfileAddress.vue?vue&type=template&id=7c7644d6"
import script from "./ProfileAddress.vue?vue&type=script&lang=js"
export * from "./ProfileAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports